import { CheckCircle } from "@mui/icons-material"
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle"
import { Chip } from "@mui/material"

/**
 * Componente que muestra un chip con un ícono y un texto,
 * indicando si un estado está activo o desactivado.
 *
 * @component
 *
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.status - Indica si el chip está activo (`true`) o desactivado (`false`).
 * @param {string} [props.activo="Activo"] - Texto que se muestra cuando el chip está activo.
 * @param {string} [props.desactivado="Desactivado"] - Texto que se muestra cuando el chip está desactivado.
 * @param {JSX.Element} [props.iconTrue=<CheckCircle />] - Ícono mostrado cuando `status` es `true`.
 * @param {JSX.Element} [props.iconFalse=<RemoveCircleIcon />] - Ícono mostrado cuando `status` es `false`.
 * @param {"small"|"medium"} [props.size="small"] - Tamaño del chip.
 *
 * @returns {JSX.Element} Un chip con ícono, texto y color dependiendo del estado.
 *
 * @example
 * // Chip activo
 * <ChipStatus status={true} />
 *
 * @example
 * // Chip desactivado con textos personalizados
 * <ChipStatus status={false} activo="Sí" desactivado="No" />
 */
export default function ChipStatus({
	status,
	activo = "Activo",
	desactivado = "Desactivado",
	iconTrue = <CheckCircle />,
	iconFalse = <RemoveCircleIcon />,
	size = "small",
}) {
	return (
		<Chip
			icon={status ? iconTrue : iconFalse}
			label={status ? activo : desactivado}
			color={status ? "success" : "error"}
			size={size}
		/>
	)
}
